import React from "react";
import { Input } from "reactstrap";
import TextareaAutosize from "react-textarea-autosize";
import { IMaskInput } from "react-imask";
import { Controller } from "react-hook-form";
import Select from 'react-select'

export const InputTypeAditionalFields = ({
  item: additionalField,
  register,
  control,
  onSetValue,
  ...props }) => {
  if (!additionalField) throw new Error(`additionalField is required property`)

  const name = additionalField.nameFieldForm
  const type = additionalField.type

  const configuration = additionalField.configuration

  if (type === 'campo livre') {
    return (
      <Controller
        as={TextareaAutosize}
        type="textarea"
        name={name}
        id={name}
        placeholder={additionalField.placeholder}
        defaultValue={additionalField?.value}
        control={control}
        minLength={additionalField.configuration?.minLength ?? null}
        maxLength={additionalField.configuration?.maxLength ?? 200}
        {...props}
      />
    );
  }

  if (type === 'money') {
    return (
      <Controller
        name={name}
        id={name}
        control={control}
        render={field => {
          return (
            <IMaskInput
              {...props}
              placeholder={additionalField.placeholder}
              ref={field.ref}
              name={field.name}
              defaultValue={additionalField?.value}
              mask={[
                {
                  mask: 'num',
                  blocks: {
                    num: {
                      // nested masks are available!
                      mask: Number,
                      thousandsSeparator: '.'
                    }
                  }
                }
              ]}
              radix={','}             
              onBlur={field.onBlur}
              onAccept={value => field.onChange(value)}
            />
          )
        }}
      />
    );
  }

  if (type === 'cpf') {
    return (
      <Controller
        name={name}
        id={name}
        control={control}
        render={field => {
          return (
            <IMaskInput
              {...props}
              placeholder={additionalField.placeholder}
              ref={field.ref}
              name={field.name}
              defaultValue={additionalField?.value}
              mask='000.000.000-00'
              onBlur={field.onBlur}
              onAccept={value => field.onChange(value)}
            />
          )
        }}
      />
    );
  }

  if (type === 'phone') {
    return (
      <Controller
        name={name}
        id={name}
        control={control}
        render={field => (
          <IMaskInput
            {...props}
            placeholder={additionalField.placeholder}
            ref={field.ref}
            name={field.name}
            defaultValue={additionalField?.value}
            mask={[{ mask: '(00) 0000-0000' }, { mask: '(00) 00000-0000' }]}
            onBlur={field.onBlur}
            onAccept={value => field.onChange(value)}
          />
        )}
      />
    );
  }

  if (type === 'select') {
    return (
      <div className="select2-container">
        <Controller
          name={name}
          control={control}
          render={(field) => {
            const handleChange = (optionOrOptions) => {
              const value = Array.isArray(optionOrOptions)
                  ? optionOrOptions.map(option => option.value)
                  : optionOrOptions.value

              field.onChange(value)
            }

            const value = configuration.isMulti
              ? configuration.options.filter(option => field.value.includes(option.value))
              : configuration.options.find(option => option.value === field.value)

            return <Select
              {...props}
              {...field}
              options={configuration.options}
              value={value}
              className="select2-selection"
              classNamePrefix="select2-selection"
              getOptionLabel={option => option.label}
              getOptionValue={option => option.value}
              isMulti={configuration.isMulti}
              onChange={handleChange}
            />
          }}
        />
      </div>
    )
  }


  return (
    <Input
      name={name}
      placeholder={additionalField.placeholder}
      type="text"
      innerRef={register}
      {...props}
    />
  )
}
